<template>
  <div v-if="order">
    <v-card-text v-if="isReceipt">
      Order id: <span class="font-weight-bold">{{ $route.params.id }}</span> <br />
      Date: <span class="font-weight-bold">{{(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)}}</span>
    </v-card-text>
    <div v-if="orderType === 'sell'">
      <div class="d-flex flex-row">
        <v-card-text>
          <span :class="fromToTypography">From</span> <br />
          You send: <br />
          <strong>{{order.coinAmount}} BTC</strong> <br />
          Equivalent in AUD: <br /> <strong>{{formatCurrency(order.audAmount)}}*</strong>
        </v-card-text>
        <v-card-text>
          <span :class="fromToTypography">To</span> <br />
          <div v-if="order.addressType === 'bank'">
            BSB <strong>{{order.address.bsb}}</strong> <br />
            Acct <strong>{{order.address.accountNumber}} </strong>
          </div>
          <div v-if="order.addressType === 'bpay'">
            Biller <strong>{{order.address.biller}} </strong><br />
            Ref <strong>{{order.address.ref}} </strong><br />
          </div>
        </v-card-text>
      </div>
      <v-card-text>
        <span class="text-caption">*Includes a flat total fee of $20.</span> <br />
      </v-card-text>
    </div>
    <div v-if="orderType === 'buy'">
      <div class="d-flex flex-row">
        <v-card-text>
          <span :class="fromToTypography">From</span> <br />
          You pay: <br /> <strong>{{formatCurrency(order.audAmount)}} AUD*</strong> <br />
        </v-card-text>
        <v-card-text class="break-all">
          <span :class="fromToTypography">To</span> <br />
          You receive: <br /> <strong>{{order.coinAmount}} {{order.coin.toUpperCase()}}**</strong> <br />
        </v-card-text>
      </div>
      <v-card-text>
        <span class="text-caption">*Includes a flat total fee of $20.</span> <br />
        <span class="text-caption">**Wallet: {{order.address.address}}</span>
      </v-card-text>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { utilsMixin } from '../mixins/utilsMixin'

export default {
  props: ['orderType', 'isReceipt'],
  mixins: [utilsMixin],
  data() {
    return {
      fromToTypography: 'font-weight-bold text-subtitle-1 white--text'
    }
  },
  computed: {
    ...mapState('order', ['order']),
  },
  mounted() {
    console.log('Order Details are:', this.order)
  }

}
</script>

<style>
/* .fromToColor {
  color: #00A2FD
} */
</style>